export default {
  state: {
    doctors: [],
  },
  mutations: {
    setDoctors(state, doctors) {
      state.doctors = doctors;
    },
  },
  actions: {
    updateDoctors({ commit }, doctors) {
      commit('setDoctors', doctors);
    },
  },
  getters: {
    getDoctors: (state) => state.doctors,
  },
};
